import { Dispatch } from "redux";
import {
    resetFormValues,
    UpsertScheduleQualificationModalInterface,
    setError,
    setIsPatchCreateScheduledQualificationSuccess,
    setIsScheduleQualificationModalOpen,
} from "../UpsertScheduleQualificationModalSlice";
import { ScheduledQualificationStatusEnum } from "../../../common/enums/ScheduledQualificationStatusEnum";
import { toast } from "react-toastify";
import { ErrorInterface } from "../../../common/interfaces/ErrorInterface";
import { useScheduleQualificationMutation } from "../../../common/api/scheduledQualification";

interface Props {
    formValues?: UpsertScheduleQualificationModalInterface["formValues"];
    scheduleQualification: ReturnType<
        typeof useScheduleQualificationMutation
    >[0];
    dispatch: Dispatch;
    establishmentId?: number | null;
}

export const handleScheduleQualification = async (
    props: Props,
): Promise<void> => {
    const { formValues, dispatch, scheduleQualification, establishmentId } =
        props;

    if (!formValues) {
        console.error("Form values are not provided");
        return;
    }

    if (!establishmentId) {
        console.error("Establishment ID is not provided");
        return;
    }

    try {
        await scheduleQualification({
            data: {
                establishment_id: establishmentId,
                qualification_id: formValues?.qualification?.value,
                employee_ids: [formValues?.employee?.value],
                educator_id: formValues?.educator?.value,
                starts_at: formValues?.startDate,
                ends_at: formValues?.endDate,
                status: ScheduledQualificationStatusEnum.SCHEDULED,
            },
        }).unwrap();

        dispatch(setIsScheduleQualificationModalOpen(false));
        dispatch(setIsPatchCreateScheduledQualificationSuccess(true));
        dispatch(resetFormValues());
        toast.success("Kwalificatie is ingepland");
    } catch (error) {
        const errorData = error as ErrorInterface;
        dispatch(setError(errorData.data.message));
    }
};
